import { Slider } from "@mui/material";
import React, { useState } from "react";
import index from "./index.css";
import PopUp from "./PopUp";

const TableSlider = ({ scrollPos, setScrollPos }) => {
  const [sp, setSP] = useState(0);
  const [showSliderPopUp, setShowSliderPopUp] = useState(true);
  const handleSlide = (e) => {
    //position[0-100 on target.value]
    setScrollPos(e.target.value);
  };
  const closePopUp = (e) => {
    setShowSliderPopUp(false);
  };
  const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  return (
    <div className="bg-light-green-200 rounded-[10px] relative flex justify-between px-[2px] py-[5px] ">
      {showSliderPopUp && (
        <PopUp
          type={"alert"}
          title={"Desliza y Visualiza"}
          message={
            "Observa toda la información deslizando la información de toda la tabla."
          }
          customPosL={"left-[-10px]"}
          customPosT={"top-[-145px]"}
          onClose={closePopUp}
        />
      )}
      {arr.map((e, i) => {
        return (
          <div
            key={i}
            className=" w-full mx-[2px] bg-light-green-50 rounded-[5px] h-[30px]"
          />
        );
      })}

      <div className="flex absolute z-20 w-full px-[28px] left-0 md:top-[5px] top-[-2px]">
        <Slider
          value={scrollPos}
          onChange={handleSlide}
          aria-label="Default"
          color="#ffffff"
        >
          asd
        </Slider>
      </div>
    </div>
  );
};

export default TableSlider;
